const config = {
  version: '2.10.3',
  type: 'js'
};

export default config;


// WEBPACK FOOTER //
// ./src/config.ts